const FIELD_MAP = {
  challenge_id: "challengeId",
  expires_at: "expiresAt",
  attempts_remaining: "attemptsRemaining",
  retry_available_at: "retryAvailableAt",
};

const applyFieldMap = (obj) => {
  if (!obj || typeof obj !== "object") return obj;
  const mapped = { ...obj };
  for (const [snakeKey, camelKey] of Object.entries(FIELD_MAP)) {
    if (snakeKey in obj) {
      mapped[camelKey] = obj[snakeKey];
    }
  }
  return mapped;
};

export const normalizeAuthResponse = (data) => {
  if (!data || typeof data !== "object") return data;
  const normalized = applyFieldMap(data);
  if (normalized.action) {
    normalized.action = applyFieldMap(normalized.action);
  }
  return normalized;
};

export const parsePinCode = (error, data) => {
  if (data) {
    return data.action?.code ?? data.code ?? null;
  }
  const responseError = error?.response?.data?.error;
  return typeof responseError === "string" ? responseError : null;
};

export const formatPinInvalidMessage = (
  data,
  fallbackMessage = "Incorrect PIN. Please try again.",
) => {
  const attemptsRemaining = data?.action?.attemptsRemaining ?? data?.attemptsRemaining;
  if (attemptsRemaining == null) return fallbackMessage;
  const attemptWord = attemptsRemaining === 1 ? "attempt" : "attempts";
  return `Incorrect PIN. ${attemptsRemaining} ${attemptWord} remaining.`;
};

export const PIN_LOCK_FALLBACK_MS = 30 * 60 * 1000;

export const computePinLockedExpiry = (data, fallbackMs) => {
  const retryAvailableAt = data?.action?.retryAvailableAt ?? data?.retryAvailableAt;
  return retryAvailableAt
    ? new Date(retryAvailableAt).getTime()
    : Date.now() + fallbackMs;
};

export const TRANSACTION_PIN_ACTION_CODES = {
  PIN_CONFIRMATION_REQUIRED: "PIN_CONFIRMATION_REQUIRED",
};

export const PIN_ERROR_CODES = {
  PIN_REQUIRED: "PIN_REQUIRED",
  PIN_SETUP_REQUIRED: "PIN_SETUP_REQUIRED",
  PIN_INVALID: "PIN_INVALID",
  PIN_LOCKED: "PIN_LOCKED",
  PIN_CHALLENGE_INVALID: "PIN_CHALLENGE_INVALID",
};

export const TRANSACTION_NOT_FOUND_MESSAGE = "Transaction not found";
